<template>
    <div>
        <marker-single
            v-for="(marker, index) in markerArray"
            :key="`${marker.id}-${marker.type}-${index}`"
            :marker="marker"
        >
        </marker-single>
    </div>
</template>
<script>
import {
    LMarker,
    LPopup,
    LTooltip,
    LIcon,
} from "vue2-leaflet";
import {mapGetters} from "vuex";
import MarkerSingle from "./MarkerSingle.vue";
import Vue from "vue";

export default {
    components: {
        LPopup,
        LMarker,
        LTooltip,
        LIcon,
        MarkerSingle,
    },
    props: {},
    data() {
        return {
            markerArray: [],
        };
    },
    mounted() {
        this.fillMarkerArray(this.markers);
    },
    methods: {
        fillMarkerArray(newValue) {
            let vm = this;
            let markerArray = [];
            let keys = newValue ? Object.keys(newValue) : null;
            if (keys.length) {
                keys.forEach((key) => {
                    newValue[key].forEach((marker) => {
                        if (marker.coordinates && marker.coordinates.length) {
                            if (this.restAreas.find((area) => area === key)) {
                                if (marker[key]) {
                                    markerArray.push({
                                        ...marker,
                                        type: marker.type ? marker.type : key,
                                        //@TODO gasStationTypes, restAreaTypes
                                    });
                                }
                            } else {
                                if (
                                    key === "enc_regular" &&
                                    this.filters.tollPlacesType.find(
                                        (filter) => filter === "enc_sale"
                                    ) &&
                                    marker.enc_sale
                                ) {
                                    return;
                                }
                                if (
                                    key === "enc_regular" &&
                                    this.filters.tollPlacesType.find(
                                        (filter) => filter === "enc_fill"
                                    ) &&
                                    marker.enc_fill
                                ) {
                                    return;
                                }
                                markerArray.push({
                                    ...marker,
                                    type: marker.type ? marker.type : key,
                                    //@TODO gasStationTypes, restAreaTypes
                                });
                            }
                        }
                    });
                });
            }
            Vue.set(vm, "markerArray", markerArray);
        },
    },
    computed: {
        ...mapGetters(["markers", "filters", "restAreas"]),
    },
    watch: {
        markers(newValue) {
            this.fillMarkerArray(newValue);
        },
    },
};
</script>
